const policyAction = {
    CANCEL : 'cancel',

    ENDORSE : 'endorse',

    REINSTATE : 'reinstate',

    REWRITE : 'rewrite',

    REISSUE : 'reissue'

};

angular.module('gw-um-j2js')
    .constant('policyAction', policyAction);